module.exports = __webpack_public_path__ + "static/logo-5653b2cab38acecfd9d6d16371273f86.svg";